import { useCallback } from 'react';
import { UseSelectionHandlingProps } from '../types';

export const useSelectionHandling = ({ onData, setSelectedRow }: UseSelectionHandlingProps) => {
  const onSelectionChange = useCallback(
    (event: any) => {
      const selectedNodes = event.api.getSelectedNodes();
      const selectedData = selectedNodes.map((node: any) => node.data);
      const areItemsSelected = selectedData.length > 0;

      setSelectedRow(selectedData);
      onData(areItemsSelected, selectedData);
    },
    [onData, setSelectedRow]
  );

  return {
    onSelectionChange,
  };
};